import permissions from '@enums/user-permissions';

const TemplateWorkflow = () => import('@/pages/templates/template-workflow/TemplateWorkflow.vue');

// Scope
const TemplateScope = () => import('@/pages/templates/template-scope/TemplateScope.vue');
const TemplateDateAssortmentGroups = () =>
  import(
    '@/pages/templates/template-scope/template-date-assortment-groups/TemplateDateAssortmentGroups.vue'
  );
const TemplateProducts = () =>
  import('@/pages/templates/template-scope/template-products/TemplateProducts.vue');
const TemplateStores = () =>
  import('@/pages/templates/template-scope/template-stores/TemplateStores.vue');

// Inputs
const TemplateInputs = () => import('@/pages/templates/template-inputs/TemplateInputs.vue');
const AttributeEditor = () => import('@/pages/scenario/input/attribute-editor/AttributeEditor.vue');
const CannGroups = () => import('@/pages/scenario/input/cann-groups/CannGroups.vue');

const routes = [
  {
    path: '/template/:templateId',
    name: 'template',
    id: 'template',
    component: TemplateWorkflow,
    linkText: 'navBar.templateWorkflow',
    meta: {
      featureKey: 'templatesEnabled',
      requiresPermission: permissions.canViewTemplates,
      titleExtension: 'navBar.templateWorkflow',
    },
    omitFromNav: true,
    children: [
      {
        path: 'scope',
        name: 'template-scope',
        component: TemplateScope,
        redirect: to => {
          // Redirect to dates-assortment-groups when just /scope is accessed
          return {
            name: 'template-dates-assortment-groups',
            params: { templateId: to.params.templateId },
          };
        },
        children: [
          {
            path: 'dates-assortment-groups',
            name: 'template-dates-assortment-groups',
            component: TemplateDateAssortmentGroups,
            omitFromNav: true,
            meta: {
              featureKey: 'templatesEnabled',
              requiresPermission: permissions.canViewTemplates,
              titleExtension: 'datesAssortmentGroupsPage.tab.datesAssortmentGroups',
            },
          },
          {
            path: 'products',
            name: 'template-products',
            component: TemplateProducts,
            omitFromNav: true,
            meta: {
              featureKey: 'templatesEnabled',
              requiresPermission: permissions.canViewTemplates,
              titleExtension: 'templateProductsPage.tab.products',
            },
          },
          {
            path: 'stores',
            name: 'template-stores',
            component: TemplateStores,
            omitFromNav: true,
            meta: {
              featureKey: 'templatesEnabled',
              requiresPermission: permissions.canViewTemplates,
              titleExtension: 'templateStoresPage.tab.stores',
            },
          },
        ],
      },
      {
        // until scenario is available
        path: ':templateScenarioId/inputs',
        name: 'template-inputs',
        component: TemplateInputs,
        children: [
          {
            path: 'attributes',
            name: 'template-attributes',
            component: AttributeEditor,
            omitFromNav: true,
            meta: {
              featureKey: 'templatesEnabled',
              requiresPermission: permissions.canViewTemplates,
              titleExtension: 'scenarioInputPage.tab.attr',
            },
          },
          {
            path: 'cann-group',
            name: 'template-cann-group',
            component: CannGroups,
            omitFromNav: true,
            meta: {
              featureKey: 'templatesEnabled',
              requiresPermission: permissions.canViewTemplates,
              titleExtension: 'scenarioInputPage.tab.cann-group',
            },
          },
        ],
      },
    ],
  },
];

export default routes;
